import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerHarvestDetail() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const data = useSelector((state) => state.harvest.data);
  const vegetable = useSelector((state) => state.vegetable.data);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    vegetableId: "",
    estimateCodeId: "",
    harvestTotal: "",
  });
  const [harvestDetails, setHarvestDetails] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          farmerId: data.docs[x].farmerId ? data.docs[x].farmerId._id : "",
          farmerName: data.docs[x].farmerId
            ? data.docs[x].farmerId.fullName
            : "",
          vegetableId: data.docs[x].vegetableId
            ? data.docs[x].vegetableId._id
            : "",
          vegetableName: data.docs[x].vegetableId
            ? data.docs[x].vegetableId.vegetableName
            : "",
          estimateCodeId: data.docs[x].estimateCodeId
            ? data.docs[x].estimateCodeId._id
            : "",
          estimateCodeName: data.docs[x].estimateCodeId
            ? data.docs[x].estimateCodeId.estimateCode
            : "",
          harvestTotal: data.docs[x].harvestTotal
            ? data.docs[x].harvestTotal
            : "",
        });
        setHarvestDetails([...data.docs[x].harvestDetails]);
      }
      setFetch(false);
    }
  }, [fetch]);

  const harvestDetailsColumn = ["TANGGAL", "JUMLAH", "DESKRIPSI"];

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL PANEN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE ESTIMASI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="estimateCodeId"
              value={formData.estimateCodeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.estimateCodeId && (
                <MenuItem value={formData.estimateCodeId}>
                  {formData.estimateCodeName}
                </MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerName && formData.farmerId.length > 0 && (
                <MenuItem value={formData.farmerId}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SAYURAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="vegetableId"
              value={formData.vegetableId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.vegetableName && formData.vegetableId.length > 0 && (
                <MenuItem value={formData.vegetableId}>
                  {formData.vegetableName}
                </MenuItem>
              )}
              {vegetable.docs.length > 0 ? (
                vegetable.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.vegetableName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <Divider />
          <div
            style={{
              background: "#d1cdcd",
              padding: "10px",
              borderRadius: "10px",
              margin: "10px 0px",
            }}
          >
            <Typography
              marginTop={1}
              marginBottom={1}
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
            >
              DETAIL PANEN
            </Typography>
            <table
              style={{
                width: "100%",
                marginBottom: "10px",
                borderCollapse: "collapse",
                borderRadius: "1em",
                overflow: "hidden",
              }}
            >
              <thead>
                {harvestDetailsColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {harvestDetails.length > 0 &&
                  harvestDetails.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              type="date"
                              error={false}
                              name="harvestDate"
                              value={item.harvestDate}
                              fullWidth
                              variant="outlined"
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ readOnly: true }}
                              required
                              size="small"
                              type="number"
                              error={false}
                              name="harvestAmount"
                              id={index}
                              value={item.harvestAmount}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 250, readOnly: true }}
                              error={false}
                              name="description"
                              id={index}
                              value={item.description}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <Divider />
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              marginTop: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL PANEN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              inputProps={{ readOnly: true }}
              type="number"
              size="small"
              error={false}
              name="harvestTotal"
              value={formData.harvestTotal}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/panen")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
